module.exports = __webpack_public_path__ + "img/logo-ckg.5ffeb19e.png";